/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import { object, string } from 'prop-types';

const styles = (theme) => ({
    imageCard: {
        width: '100%',
        borderRadius: 0,
        position: 'relative',
        '& h2': {
            position: 'absolute',
            bottom: 0,
            left: 0,
            opacity: 0,
        },
    },
    productImage: {
        display: 'block',
        width: 'inherit',
    },
    productLink: {
        textDecoration: 'none',
    },
    videoContainer: {
        '& $imageCard': {
            minHeight: '393px',
            [theme.breakpoints.down('600')]: {
                minHeight: '250px',
            },
        },
        '& video': {
            padding: '15px',
        },
        '& p ': {
            padding: '15px',
            textAlign: 'center',
            fontSize: '23px',
            [theme.breakpoints.down('600')]: {
                fontSize: '17px',
            },
        },
    },
});

const loadImageBlock = (classes, url, title, isFoodBrand) => (
    <Card className={classes.imageCard}>
        <img
            src={url}
            alt={title}
            className={classes.productImage}
        />
        {/* for seo values */}
        {title && isFoodBrand && (<div>{title}</div>)}
    </Card>
);
const loadVideoBlock = (classes, url, name) => (
    <Card className={classes.imageCard}>
        <video controls width="100%" height="100%">
            <source src={url} type="video/mp4" preload="metadata" />
            <track kind="captions" />
        </video>
        <Typography>{name}</Typography>
    </Card>
);

const GraphqlIcBanner = ({
    classes, icBannerBlock = {}, presentation_family,
}) => {
    const isFoodBrand = presentation_family === 'food';
    if (icBannerBlock !== null) {
        const { link: { href = '', title = '' } = {}, name = '' } = icBannerBlock;
        const contentType = icBannerBlock.image?.content_type || null;
        const url = icBannerBlock.image?.url || null;
        switch (contentType) {
            case 'image/jpeg':
            case 'image/png':
            case 'image/gif':
                if (href?.indexOf('http://') === 0 || href?.indexOf('https://') === 0) {
                    return (
                        url
                            ? (
                                <a href={href} className={classes.productLink}>
                                    {loadImageBlock(classes, url, title, isFoodBrand)}
                                </a>
                            ) : null
                    );
                }
                if (href && url) {
                    return (
                        <Link to={href} title={title} className={classes.productLink}>
                            {loadImageBlock(classes, url, title, isFoodBrand)}
                        </Link>
                    );
                } return (
                    url
                        ? (
                            loadImageBlock(classes, url, title, isFoodBrand)
                        ) : null
                );
            case 'video/mp4':
                return (
                    // eslint-disable-next-line no-nested-ternary
                    (href && url) ? (
                        <div className={classes.videoContainer}>
                            <Link to={href} title={title} className={classes.productLink}>
                                {loadVideoBlock(classes, url, name)}
                            </Link>
                        </div>
                    )
                        : (
                            url ? (
                                <div className={classes.videoContainer}>
                                    {loadVideoBlock(classes, url, name)}
                                </div>
                            ) : null
                        )
                );
            default:
                return null;
        }
    } return null;
};

GraphqlIcBanner.propTypes = {
    classes: object,
    icBannerBlock: object,
    presentation_family: string.isRequired,
};
GraphqlIcBanner.defaultProps = {
    classes: {},
    icBannerBlock: {},
};

export default withStyles(styles)(GraphqlIcBanner);
